import React, { Suspense } from 'react';
import UILoader from 'components/UI/Loader/Loader';
import BaseLayout from 'components/BaseLayout/BaseLayout';
import DocumentTitle from 'components/DocumentTitle/DocumentTitle';
import { RoutePrivateProps } from 'components/Route/Private/types';

const UserForm = React.lazy(() => import('components/User/Form/Form'));

function ScreensUserForm(params: Readonly<RoutePrivateProps>) {
  return (
    <BaseLayout className="background-blue">
      <DocumentTitle>{params.id ? 'Edit' : 'Create'} User</DocumentTitle>
      <Suspense fallback={<UILoader />}>
        <UserForm id={params.id ? parseInt(params.id as string, 10) : null} />
      </Suspense>
    </BaseLayout>
  );
}

export default ScreensUserForm;
